import { getCookie } from '../hooks/sfetch';

// The generated client cannot carry binary: sfetchMutator always calls response.json().
export async function downloadFromApi(url: string, filename: string): Promise<number> {
    const csrf = getCookie('token');
    const response = await fetch(url, {
        credentials: 'include',
        headers: csrf ? { 'X-CSRF-Token': csrf } : undefined,
    });
    if (!response.ok) return response.status;

    saveBlob(await response.blob(), serverFilename(response) ?? filename);
    return 0;
}

function serverFilename(response: Response): string | null {
    const disposition = response.headers.get('content-disposition');
    return disposition?.match(/filename="?([^";]+)"?/i)?.[1] ?? null;
}

export function saveBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
